import { useMutation } from '@tanstack/react-query';
import {
  type DashboardExecuteRequest,
  type DashboardExecuteResponse,
  executeDashboard,
} from '../lib/dashboards-client.js';

export function useExecuteDashboard(tenantReportId: string) {
  return useMutation<DashboardExecuteResponse, Error, DashboardExecuteRequest>({
    mutationFn: (body: DashboardExecuteRequest) => executeDashboard(tenantReportId, body),
  });
}
